import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import crmVideo from '../../assets/crm/crmvideo.mp4';
import './Hero.css';

const Hero = () => {
  const videoRef = useRef(null);

  const enforceMuted = () => {
    const videoEl = videoRef.current;
    if (!videoEl) return;
    // Ses hiçbir koşulda açılmasın
    videoEl.muted = true;
    videoEl.defaultMuted = true;
    videoEl.volume = 0;
  };

  useEffect(() => {
    enforceMuted();
  }, []);

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <motion.div
            className="hero-text"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <motion.h1
              className="hero-title"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              İşinizi Büyütmek İçin
              <span className="gradient-text"> Kapsamlı CRM Çözümü</span>
            </motion.h1>
            
            <motion.p
              className="hero-subtitle"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              Gününüzü iş planlarıyla planlayın, ekibinize görevler atayın ve çalışanlarınızın
              yoğunluk durumunu takip ederek yönetilebilirliği artırın.
            </motion.p>

            <motion.div
              className="hero-stats"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.8 }}
            >
              <div className="stat-item">
                <div className="stat-number">50+</div>
                <div className="stat-label">Müşteri</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">30K+</div>
                <div className="stat-label">İşlem Günlüğü</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">%99</div>
                <div className="stat-label">Uptime</div>
              </div>
            </motion.div>
          </motion.div>

          <motion.div
            className="hero-visual"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <div className="hero-image-wrapper">
              {/* CRM Video */}
              <div className="hero-video-wrapper">
                <video 
                  ref={videoRef}
                  className="hero-video"
                  controls
                  autoPlay
                  loop
                  muted
                  defaultMuted
                  playsInline
                  onPlay={enforceMuted}
                  onPlaying={enforceMuted}
                  onVolumeChange={enforceMuted}
                >
                  <source src={crmVideo} type="video/mp4" />
                  Tarayıcınız video oynatmayı desteklemiyor.
                </video>
              </div>
              
              <div className="hero-gradient"></div>
            </div>
          </motion.div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <motion.div
        className="scroll-indicator"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 1 }}
      >
        <div className="scroll-mouse">
          <div className="scroll-wheel"></div>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;

